// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:992px){.aside{display:none}.aside_mobile{display:block}.name{display:none}}@media screen and (min-width:993px){.aside{display:block}.aside_mobile{display:none}.name{display:inline-block}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
